export type MentionTrigger = {
  kind: 'MEMBER' | 'ELEMENT'
  query: string
  start: number
}

// `@` summons the member picker; `/` summons the workspace-item (element,
// checklist, …) picker. `#` is reserved for user-typed tags — the tag
// extractor pattern (see HASHTAG_PATTERN in TeamGroupChat) treats every `#foo`
// in a message as a tag, so keeping `#` free of the element picker prevents
// element titles from being double-counted as tags.
export const parseMentionTrigger = (text: string): MentionTrigger | null => {
  const match = text.match(/(^|\s)([@/])([^\s@/]*)$/)
  if (!match || match.index === undefined) return null
  return {
    kind: match[2] === '@' ? 'MEMBER' : 'ELEMENT',
    query: match[3].toLowerCase(),
    start: match.index + match[1].length,
  }
}

export const removeMentionTrigger = (text: string, trigger: MentionTrigger) =>
  `${text.slice(0, trigger.start)}${text.slice(trigger.start).replace(/^[@/][^\s@/]*$/, '')}`
